import React from "react";
import { useI18n } from "../../providers/I18nProvider";

const CLASS_BY_PRIORITY = {
  low: "sat-priority sat-priority--low",
  medium: "sat-priority sat-priority--medium",
  high: "sat-priority sat-priority--high",
};

const PriorityBadge = ({ priority }) => {
  const { t } = useI18n();
  const className = CLASS_BY_PRIORITY[priority] || "sat-priority";
  return <span className={className}>{t(`satRequest.priority.${priority}`) || priority}</span>;
};

export default PriorityBadge;
